import React, { useState, useEffect } from "react";

import {
  Row,
  Col
} from "react-bootstrap";
import { Link } from "react-router-dom";
import BackImg from "../assets/images/cart/back-icon.svg";
import DownloadImg from "../assets/images/profile/DownloadImg.svg";
import ArrowIcon2 from "../assets/images/blog/arrow-down.svg";
import Visa from "../assets/images/profile/visa.svg";
import MasterCard from "../assets/images/profile/master-card.svg";
import AmericanExpress from "../assets/images/profile/american-express.svg";
import Discover from "../assets/images/cart/discover.svg";

import CallImg from "../assets/images/contact/call.svg";
import EmailImg from "../assets/images/contact/mail.svg";
import "@smastrom/react-rating/style.css";

import { formatPrice, formatDate, formatPhoneNumber } from "../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderList,
  clearOrderMessages,
} from "../features/order/orderActions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


function MyServicesComp() {

  const [isActive, setIsActive] = useState(false);
  const handleToggle = () => {
    setIsActive((prevState) => !prevState);
  };

  const [orderDetails, setOrderDetails] = useState(null);

  // State to manage pagination
  const [page, setPage] = useState(1);

  // State to store all fetched orders
  const [allOrders, setAllOrders] = useState([]);

  // visible show more
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(true);

  const dispatch = useDispatch();
  const { loading, errorMessage, orderList } = useSelector(
    (state) => state.order
  );

  useEffect(() => {
    setAllOrders([]);
    let data = { page: 1, limit: 3 };
    dispatch(fetchOrderList(data));
  }, [dispatch]);

  useEffect(() => {
    if (orderList?.data) {
      setAllOrders((prev) => [...prev, ...orderList.data]);
      setIsVisibleShowMore(orderList.data.length >= 3);
    } else {
      setIsVisibleShowMore(false);
    }
  }, [orderList]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearOrderMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  const loadMoreOrders = () => {
    const nextPage = page + 1;
    let data = { page: nextPage, limit: 3 };
    dispatch(fetchOrderList(data));
    setPage(nextPage); // Update the page number
  };

  const openOrderDetails = (order) => {
    setOrderDetails(order);
    handleToggle();
  };

  useEffect(() => {}, [orderDetails]);

  return (
    <>
      <div className={`${isActive ? "isHide" : ""}`}>
        <div className="tab-content-header">
          <h3>My Services</h3>
        </div>
        <div className="tab-content-body">
          <div className="card-list">
            {loading && allOrders.length === 0 ? (
              <p>Loading...</p>
            ) : allOrders?.length > 0 ? (
              <>
                {allOrders.map((order, index) => (
                  <div className="card-list-item" key={order.id}>
                    <div className="card-cell d-flex flex-column">
                      <span className="mb-0">Order Number</span>
                      <h4>{order.order_number}</h4>
                    </div>
                    <div className="card-cell">
                      <span>Purchased Date</span>
                      <h4>{formatDate(order.created_at)}</h4>
                    </div>
                    <div className="card-cell">
                      <span>Amount</span>
                      <h4>$ {formatPrice(order.total_amount)}</h4>
                    </div>
                    <div className="card-cell flex-row">
                      <Link className="custom-bttn active-bttn" to="">
                        Active
                      </Link>
                      <Link
                        className="custom-bttn"
                        onClick={() => openOrderDetails(order)}
                      >
                        View Details
                      </Link>
                    </div>
                  </div>
                ))}

                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    onClick={loadMoreOrders}
                    className={`custom-bttn ${
                      !isVisibleShowMore ? "d-none" : ""
                    }`}
                  >
                    {loading ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        size="lg"
                        className="spinner-icon"
                      />
                    ) : (
                      <>
                        Show More <img src={ArrowIcon2} alt="" />
                      </>
                    )}
                  </Link>
                </div>
              </>
            ) : (
              <p>No services found in the account.</p>
            )}
          </div>
        </div>
      </div>
      <div className={`${isActive ? "" : "isHide"}`}>
        <div className="tab-content-header">
          <div>
            <h3>
              <Link to="" className="backToList" onClick={handleToggle}>
                <img src={BackImg} alt="" />
              </Link>{" "}
              {orderDetails?.order_number}
            </h3>
          </div>
          <div className="d-flex justify-content-center align-content-center">
            <div className="d-flex flex-column pe-3">
              <span>Purchased Date</span>
              <h6>{formatDate(orderDetails?.created_at)}</h6>
            </div>
            <div className="flex-row">
              <a
                target="_blank"
                rel="noreferrer"
                href={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${orderDetails?.invoice_file}`}
                download
                className="custom-bttn track-order-bttn"
              >
                <img src={DownloadImg} alt="" /> Invoice
              </a>
            </div>
          </div>
        </div>
        <div className="service-details">
          <div className="card-list">
            <div className="card-list-item">
              {orderDetails?.order_items?.length > 0 && (
                <>
                  {orderDetails.order_items.map((item, index) => (
                    <div className="card-list-item-wrap" key={"item-" + index}>
                      <div className="card-cell flex-column">
                        <span className="mb-0">Service Name</span>
                        <h4>{item.service?.title}</h4>
                      </div>
                      <div className="card-cell">
                        <span>Price</span>
                        <h4>$ {formatPrice(item.selling_price)}</h4>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {orderDetails?.payment_obj !== null && (
                <div className="payment-m-s">
                  <Row>
                    <Col md="12" lg="7">
                      <h3>Payment Method :</h3>
                      <div className="card-list">
                        <div className="card-list-item">
                          <div className="card-cell ">
                            <img
                              className="card-img"
                              src={
                                orderDetails?.payment_obj?.card_type === "visa"
                                  ? Visa
                                  : orderDetails?.payment_obj?.card_type ===
                                    "mastercard"
                                  ? MasterCard
                                  : orderDetails?.payment_obj?.card_type ===
                                    "amex"
                                  ? AmericanExpress
                                  : orderDetails?.payment_obj?.card_type ===
                                    "discover"
                                  ? Discover
                                  : orderDetails?.payment_obj?.card_type ===
                                    "diners"
                                  ? AmericanExpress
                                  : orderDetails?.payment_obj?.card_type ===
                                    "jcb"
                                  ? AmericanExpress
                                  : null
                              }
                              alt="card"
                            />
                          </div>
                          <div className="card-cell">
                            <span>Card Number</span>
                            <h4>
                              **** **** ****{" "}
                              {orderDetails?.payment_obj?.card_number}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <h3>Update Sent On :</h3>
                      <div className="get-in-touch">
                        {orderDetails?.user_obj?.mobile_number && (
                          <div className="get-in-touch-list">
                            <div className="get-in-touch-img">
                              <img src={CallImg} alt="" />
                            </div>
                            <div className="get-in-touch-list-text">
                              <a
                                href={`tel:${formatPhoneNumber(
                                  orderDetails.user_obj.mobile_number
                                )}`}
                              >
                                {formatPhoneNumber(
                                  orderDetails.user_obj.mobile_number
                                )}
                              </a>
                            </div>
                          </div>
                        )}

                        {orderDetails?.user_obj?.email && (
                          <div className="get-in-touch-list">
                            <div className="get-in-touch-img">
                              <img src={EmailImg} alt="" />
                            </div>
                            <div className="get-in-touch-list-text">
                              <a href={`mailto:${orderDetails.user_obj.email}`}>
                                {orderDetails?.user_obj?.email}
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col md="12" lg="5">
                      <h3>Payment Summary :</h3>
                      <div className="summary-box">
                        <div className="summary-box-items">
                          <p>Total Service Amount</p>
                          <p>
                            <b>${formatPrice(orderDetails?.order_amount)}</b>
                          </p>
                        </div>

                        {orderDetails?.tax_amount > 0 && (
                          <div className="summary-box-items">
                            <p>Tax</p>
                            <p>
                              <b>+${formatPrice(orderDetails?.tax_amount)}</b>
                            </p>
                          </div>
                        )}

                        {orderDetails?.discount_amount > 0 && (
                          <div className="summary-box-items">
                            <p>Discounts</p>
                            <p className="text-green">
                              <b>
                                -${formatPrice(orderDetails.discount_amount)}
                              </b>
                            </p>
                          </div>
                        )}

                        <div className="summary-box-items total">
                          <p>Payable Amount</p>
                          <p>
                            <b>${formatPrice(orderDetails?.total_amount)}</b>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

             
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MyServicesComp;
